export default __webpack_public_path__ + "static/media/no-shift-stars.b9dce557.svg";